
export default {
  name: 'SearchResultsProductsChip',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
  },
  methods: {
    remove() {
      this.$emit('remove', this.item);
    },
  },
};
